import styled from 'styled-components'
import { MqTablet, MqDesktop } from 'streamr-ui/css/consts'

const Divider = styled.div`
    height: 1px;
    background-color: #E7E7E7;
    margin: 0 2rem;

    @media ${MqTablet} {
        margin: 0 auto;
        max-width: 480px;
    }

    @media ${MqDesktop} {
        margin: 0 auto;
        max-width: 704px;
    }
`

export default Divider
